const resetModalScroll = (
  elementScrollSelector: string = '.v-dialog.v-dialog--active > div > .v-card',
) => {
  const elemetScroll = document.querySelectorAll(elementScrollSelector);
  if (!!elemetScroll.length) {
    elemetScroll[0].scrollTop = 0;
  }
};

export { resetModalScroll };
